var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({on:{"click":_vm.onClick}},'b-button',{
    variant: _vm.variant,
    size: 'md',
    block: _vm.block
  },false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }